import React, { useState } from "react";
import { useNavigate } from "react-router";
import ArrowButton from "../../components/ArrowButton";
import TextInput from "../../components/TextInput";
import infoIcon from "../../assets/images/svg/info.svg";
import { ERROR_CODES } from "../../utils/errorConstants";
import { Observer, observer } from "mobx-react";
import AuthStore from "../../store/AuthStore";
import SettingsStore from "../../store/SettingsStore";
import {
  getBlobToBase64,
  getDecodedToken,
  logEvents,
  setGAProperties,
  trackEvent,
} from "../../utils/functions";
import { getValue, setValue } from "../../utils/indexedDB";
import Log from "../../components/Analytics/Equity/Log";
// import moengage from "@moengage/web-sdk";
import { EMPLOYEE, EMPLOYEE_TYPE } from "../../utils/constants";
import { getAnalytics, setUserId } from "firebase/analytics";
const EmployeeLogin = observer(() => {
  const analytics = getAnalytics();
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({
    username: "",
    password: "",
  });
  const [isEyeOpen, setIsEyeOpen] = useState(false);

  const [error, setError] = useState({
    state: false,
    msg: "",
  });
  const [showInfo, setInfo] = useState(true);

  const handleChange = (e) => {
    setError({ state: false, msg: "" });
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    try {
      if (credentials.username && credentials.password) {
        const val = await getValue("User");
        if (val === undefined) window.location.reload(true);
        else {
          AuthStore.updateLoadingForLogin(true);
          AuthStore.getServerMsg({
            onSuccess: () => {
              AuthStore._employeeLogin(
                {
                  Password: credentials.password,
                  UserName: credentials.username,
                },
                {
                  onFail: (error, msg) => {
                    AuthStore.updateLoadingForLogin(false);

                    if (
                      error.response.data.statusCode === 1013 ||
                      error.response.data.statusCode === 1014
                    ) {
                      navigate("/blocked");
                    }
                    if (ERROR_CODES[error.response.data.statusCode]) {
                      setError({
                        state: true,
                        msg: ERROR_CODES[error.response.data.statusCode],
                      });
                    } else {
                      setError({
                        state: true,
                        msg: error.response.data.statusMessage,
                      });
                    }
                  },
                  onSuccess: (data) => {
                    AuthStore.setAuthSession({
                      AuthToken: data.token,
                      SecreteKey: data.secretKey,
                    });
                    setValue("employeeFamilies", data.familiesList);
                    setValue("rememberedFamilyData", data.familiesList);
                    setValue("showFamilyData", data.familiesList);
                    const { full_name, user_id } = getDecodedToken();

                    // moengage.add_unique_user_id(user_id).then(() => {
                    //   moengage.add_first_name(full_name);
                    //   moengage.add_user_attribute("User Type", EMPLOYEE_TYPE);
                    // });

                    setUserId(analytics, user_id);

                    setGAProperties({
                      first_name: full_name,
                      user_type: EMPLOYEE_TYPE,
                    });
                    trackEvent(EMPLOYEE);
                    logEvents(EMPLOYEE);
                    const imageArr = {};
                    data.familiesList.forEach((eachFamily) => {
                      eachFamily.memberList.forEach((eachClient) => {
                        if (eachClient.profile_pic && false) {
                          SettingsStore.getImageFromAPI({
                            path: eachClient.profile_pic,
                            onSuccess: (imageBlob) => {
                              getBlobToBase64(imageBlob).then((url) => {
                                let resImage = url;
                                imageArr[eachClient.user_id] = resImage;
                                AuthStore.updateSelectFamiliesPageAllImages(
                                  imageArr,
                                );
                              });
                            },
                          });
                        }
                      });
                    });
                    navigate("/selectfamilies", {
                      state: { from: "loginPage" },
                    });
                    AuthStore.updateLoadingForLogin(false);
                  },
                },
              );
            },
            onFail: () => {
              setError({
                state: true,
                msg: "Sorry we are down for maintenance",
              });
            },
          });
          setInfo(false);
        }
      }
    } catch (error) {
      Log("Error", error);
    }
  };

  const handleOnEnter = (e) => {
    if (e.key === "Enter") {
      handleSubmit();
    }
  };

  return (
    <Observer>
      {() => (
        <div className="login-box">
          <div>
            <TextInput
              className="username"
              type={"text"}
              value={credentials.username}
              label={"Username"}
              onChange={handleChange}
              name={"username"}
              onKeyDown={handleOnEnter}
              elementId={"enter-username"}
            />

            <TextInput
              className="password"
              isEyeOpen={isEyeOpen}
              setIsEyeOpen={setIsEyeOpen}
              error={error.state}
              errorMsg={error.msg}
              onKeyDown={handleOnEnter}
              value={credentials.email}
              label={"Password"}
              type={isEyeOpen ? "text" : "password"}
              onChange={handleChange}
              name={"password"}
              elementId={"enter-password"}
            />

            {showInfo && (
              <div
                style={{ display: "flex", gap: "10px" }}
                className="showInfobox"
              >
                <img className="clickable" src={infoIcon} alt="info" />
                <p>Please use window credentials to login</p>
              </div>
            )}
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "auto",
            }}
          >
            <ArrowButton
              type="previous"
              label="Go Back"
              onClick={() => navigate("/login/user")}
              className={"login-page"}
            />
            <ArrowButton
              disabled={!(credentials.username && credentials.password)}
              type="next"
              label="Continue"
              onClick={handleSubmit}
              className={"login-page"}
            />
          </div>
        </div>
      )}
    </Observer>
  );
});

export default EmployeeLogin;
